import React from "react";
import { Link } from "react-router-dom";

const BYU_NAVY = "#002E5D";
const BYU_BLUE = "#0057B7";
const BYU_BG = "#F5F7FA";

const About = () => (
    <section
        className="about-section py-5 d-flex flex-column"
        style={{
            flex: 1,
            display: "flex",
            minHeight: 0,
            background: BYU_BG,
        }}
    >
        <div className="container flex-grow-1 d-flex flex-column justify-content-center">
            <div className="row align-items-center">
                {/* Profile and Intro */}
                <div className="col-md-4 text-center mb-4 mb-md-0">
                    <div
                        style={{
                            flex: 1,
                            borderRadius: "50%",
                            border: `6px solid ${BYU_BLUE}`,
                            width: 180,
                            height: 180,
                            margin: "0 auto",
                            overflow: "hidden",
                            boxShadow: "0 4px 24px rgba(0,46,93,0.10)",
                            background: "#fff"
                        }}
                    >
                        <img
                            src={process.env.PUBLIC_URL + "/logo.png"}
                            alt="Adam Griffin"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover"
                            }}
                        />
                    </div>
                    <h3 className="mt-3 mb-1" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 700, color: BYU_NAVY }}>
                        Adam Griffin
                    </h3>
                    <div className="mb-2" style={{ fontWeight: 500, color: BYU_BLUE }}>
                        MSIS Student & IT Professional
                    </div>
                    <p className="fst-italic" style={{ fontSize: "1rem", color: BYU_NAVY }}>
                        Game changer, Lifelong Learner
                    </p>
                </div>
                {/* Details and Timeline */}
                <div className="col-md-8">
                    <h2 className="mb-3" style={{ fontWeight: 700, color: BYU_NAVY }}>
                        About Me
                    </h2>
                    <p style={{ color: BYU_NAVY }}>
                        I’m a BYU Computer Science graduate and U of U MSIS student, currently working as a Junior Network Administrator. I thrive at the intersection of technology, security, and teamwork.
                    </p>
                    <div className="row text-center mt-4 mb-4">
                        <div className="col-12 col-md-4 mb-3 mb-md-0">
                            <div className="p-3 rounded shadow-sm bg-white h-100">
                                <i className="bi bi-shield-lock" style={{ fontSize: 32, color: BYU_BLUE }}></i>
                                <h5 className="mt-2 mb-1" style={{ color: BYU_NAVY }}>Cybersecurity</h5>
                                <div style={{ fontSize: 14, color: BYU_NAVY }}>Network & application security</div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4 mb-3 mb-md-0">
                            <div className="p-3 rounded shadow-sm bg-white h-100">
                                <i className="bi bi-cpu" style={{ fontSize: 32, color: BYU_BLUE }}></i>
                                <h5 className="mt-2 mb-1" style={{ color: BYU_NAVY }}>Software Engineering</h5>
                                <div style={{ fontSize: 14, color: BYU_NAVY }}>Python, TypeScript, React</div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="p-3 rounded shadow-sm bg-white h-100">
                                <i className="bi bi-lightbulb" style={{ fontSize: 32, color: BYU_BLUE }}></i>
                                <h5 className="mt-2 mb-1" style={{ color: BYU_NAVY }}>AI & Automation</h5>
                                <div style={{ fontSize: 14, color: BYU_NAVY }}>Machine learning & process automation</div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-5">
                        <h6 className="text-uppercase mb-3" style={{ letterSpacing: 1, color: BYU_BLUE }}>Journey</h6>
                        <ul className="timeline list-unstyled ps-0">
                            <li className="mb-3">
                                <span className="fw-bold" style={{ color: BYU_BLUE }}>April 2025</span> – Graduated with B.S. in Computer Science from BYU
                            </li>
                            <li className="mb-3">
                                <span className="fw-bold" style={{ color: BYU_BLUE }}>July 2025</span> – Started working as a Junior Network Administrator
                            </li>
                            <li className="mb-3">
                                <span className="fw-bold" style={{ color: BYU_BLUE }}>August 2025</span> – Began MSIS at University of Utah
                            </li>
                        </ul>
                    </div>

                    {/* Call to Action */}
                    <div className="mt-4 d-flex flex-wrap gap-3">
                        <Link to="/projects" className="btn btn-primary px-4" style={{ background: BYU_NAVY, borderColor: BYU_NAVY }}>My Projects</Link>
                        <Link to="/contact" className="btn btn-outline-primary px-4" style={{ color: BYU_NAVY, borderColor: BYU_NAVY }}>Contact Me</Link>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default About;